module.exports = __webpack_public_path__ + "img/mp-flow.db6719d0.png";